module.exports = __webpack_public_path__ + "img/2560x1480-60.5dcef519.gif";